import { Button } from 'components/universal/button';
import { useTranslation } from 'react-i18next';
import { Course } from 'types/elearning';
import { employeesInterface } from 'views/employee-management';
import cls from './downloadCertificateModal.module.scss';
import { Trans } from 'react-i18next';

interface DownloadCertificateModalProps {
    downloadCertificateModalType: 'bulk' | 'single' | null;
    selectedCourseIds: number[];
    allCourses: Course[];
    coursesLoading: boolean;
    coursesError: any;
    downloadModalEmployee?: employeesInterface | null;
    setSelectedCourseIds: (ids: number[]) => void;
    confirmDownloadCertificateModal: () => void;
    cancelDownloadCertificateModal: () => void;
}

export const DownloadCertificateModal = ({
    downloadCertificateModalType,
    selectedCourseIds,
    allCourses,
    coursesLoading,
    coursesError,
    downloadModalEmployee,
    setSelectedCourseIds,
    confirmDownloadCertificateModal,
    cancelDownloadCertificateModal,
}: DownloadCertificateModalProps) => {
    const { t } = useTranslation();

    if (!downloadCertificateModalType) {
        return null;
    }

    const isSingle = downloadCertificateModalType === 'single';
    const employeeName = downloadModalEmployee 
        ? `${downloadModalEmployee.first_name} ${downloadModalEmployee.last_name}` 
        : '';

    return (
        <>
            <h3 className={cls.modalTitle}>
                {isSingle
                    ? `${t('employeeManagement.downloadCertificateDialogTitle')}: ${employeeName}`
                    : t('employeeManagement.downloadCertificatesDialogTitle')}
            </h3>

            { !isSingle && (
                <p className={cls.modalDescription}>
                    <Trans i18nKey="employeeManagement.downloadCertificatesDialogDescription" components={{ bold: <strong /> }} /> 
                </p>
            )}
            
            {coursesLoading && <p>{t('employeeManagement.loadingCourses')}</p>}
            {coursesError && <p>{t('employeeManagement.coursesLoadError')}</p>}

            {selectedCourseIds.length > 0 && (
                <div className={`${cls.courseCheckboxes} ${isSingle ? cls.courseCheckboxesSingle : ''}`}>
                    {allCourses
                        .filter((course) => selectedCourseIds.includes(course.id))
                        .map((course) => (
                            <label key={course.id} className={cls.checkboxItem}>
                                <input
                                    type={'checkbox'}
                                    name={`course-${course.id}`}
                                    className={cls.checkbox}
                                    value={course.id}
                                    checked={selectedCourseIds.includes(course.id)}
                                    onChange={(e) => {
                                        if (isSingle) {
                                            setSelectedCourseIds([course.id]);
                                        } else {
                                            const newIds = selectedCourseIds.includes(course.id)
                                                ? selectedCourseIds.filter((id) => id !== course.id)
                                                : [...selectedCourseIds, course.id];
                                            setSelectedCourseIds(newIds);
                                        }
                                    }}
                                />
                                <span className={cls.fakeCheckbox}></span>
                                <span className={cls.courseCheckboxesLabel}>{course.name || course.path}</span>
                            </label>
                        ))}
                </div>
            )}

            { isSingle && (
                <p className={`${cls.modalDescription} ${cls.modalDescriptionBottom}`}>
                    {t('employeeManagement.downloadCertificateDialogDescription')}
                </p>
            )}

            <div className={cls.downloadModalActions}>
                <Button className={cls.button} styleType="border" onClick={cancelDownloadCertificateModal}>
                    {t('employeeManagement.cancel')}
                </Button>
                <Button
                    className={cls.button}
                    onClick={confirmDownloadCertificateModal}
                    disabled={selectedCourseIds.length === 0}
                >
                    {t('employeeManagement.generateAndDownload')}
                </Button>
            </div>
        </>
    );
};
